import { ChangeEventHandler, FocusEventHandler, memo } from "react";
import { FormFeedback, Input as ReactStrapInput, Label } from "reactstrap";
import { getIn } from "formik";
import { InputProps } from "reactstrap/types/lib/Input";

export interface InputPropsForm {
    handleChange?: ChangeEventHandler;
    handleBlur?: FocusEventHandler;
    touched: any;
    errors: any;
}

interface Props extends Omit<InputProps, 'form'> {
    form: InputPropsForm;
    label?: string;
    afterLabel?: string;
    placeholder?: string;
    name: string;
}

const Input = ({ form, label = '', afterLabel = '', placeholder = '', name, ...otherProps }: Props) => {
    const invalid = !!(getIn(form.touched, name) && getIn(form.errors, name));
    return (
        <>
            {(label || afterLabel) && <Label className="form-label">{label}{afterLabel && (<span className="fw-normal">{afterLabel}</span>)}</Label>}
            <ReactStrapInput
                name={name}
                type="text"
                placeholder={placeholder}
                onChange={form.handleChange}
                onBlur={form.handleBlur}
                invalid={invalid}
                {...otherProps}
            />
            {invalid ? (
                <FormFeedback type="invalid">
                    {getIn(form.errors, name)}
                </FormFeedback>
            ) : null}
        </>
    );
};

export default memo(Input);
